// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-datepicker {
    border-radius: 2px;
}
.react-datepicker__triangle {
    display: none;
}
.react-datepicker__navigation {
    line-height: 32px;
}
.react-datepicker-wrapper {
    width: 100%;
    height: 100%;
}

/* additional styles for editable table */
.editable-cell .react-datepicker-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.editable-cell .react-datepicker-wrapper > .react-datepicker__input-container {
    height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/datepicker/datepickerCSS.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,yCAAyC;AACzC;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;AAChB","sourcesContent":[".react-datepicker {\n    border-radius: 2px;\n}\n.react-datepicker__triangle {\n    display: none;\n}\n.react-datepicker__navigation {\n    line-height: 32px;\n}\n.react-datepicker-wrapper {\n    width: 100%;\n    height: 100%;\n}\n\n/* additional styles for editable table */\n.editable-cell .react-datepicker-wrapper {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n.editable-cell .react-datepicker-wrapper > .react-datepicker__input-container {\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
